import { Loader } from '@googlemaps/js-api-loader';

const googleMapLoader = new Loader( {
	apiKey: 'AIzaSyCEoWfCVhiIdA8qjm85fLQAkk5EnbJNJ7I',
	version: 'weekly',
} ).load().then( () => {
	const coordinates = { lat: -36.8061812, lng: 174.6364264 };
	const map = new google.maps.Map( document.getElementById( 'map' ), {
		center: coordinates,
		zoom: 14,
		disableDefaultUI: true,
	} );

	new google.maps.Marker( {
		position: coordinates,
		map,
		title: 'Hello World!',
	} );
} );
